// ============================================================================
// 💀 SKELETONLOADER — Loading Fantasma para Listas
// src/features/mensagens/components/shared/SkeletonLoader.jsx
// ============================================================================

import React, { memo } from 'react';
import { motion } from 'framer-motion';

const SkeletonLoader = memo(({ count = 5, variant = 'conversation' }) => {
  if (variant === 'conversation') {
    return (
      <div className="divide-y divide-gray-100">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 px-4 py-3">
            {/* Avatar fantasma */}
            <div className="w-12 h-12 rounded-full bg-gray-200 animate-pulse flex-shrink-0" />

            {/* Contenido fantasma */}
            <div className="flex-1 min-w-0 space-y-2">
              {/* Nombre + hora */}
              <div className="flex items-center justify-between gap-2">
                <div className="h-3.5 bg-gray-200 animate-pulse rounded w-28" />
                <div className="h-3 bg-gray-100 animate-pulse rounded w-10 flex-shrink-0" />
              </div>
              {/* Preview */}
              <div className="flex items-center justify-between gap-2">
                <div className="h-3 bg-gray-100 animate-pulse rounded w-48" />
                <div className="h-5 w-5 bg-gray-100 animate-pulse rounded-full flex-shrink-0" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'chat') {
    return (
      <div className="flex flex-col gap-4 p-4">
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className={`flex ${i % 2 === 0 ? 'justify-start' : 'justify-end'}`}
          >
            <div
              className={`h-10 bg-gray-200 animate-pulse rounded-2xl ${
                i % 2 === 0 ? 'w-3/5 rounded-tl-sm' : 'w-2/5 rounded-tr-sm'
              }`}
            />
          </div>
        ))}
      </div>
    );
  }

  return null;
});

SkeletonLoader.displayName = 'SkeletonLoader';
export { SkeletonLoader };
export default SkeletonLoader;